import { type RefObject, useEffect, useState } from 'react';

interface InViewOptions {
  /** Запас вокруг экрана, как rootMargin у IntersectionObserver: '400px 0px' */
  margin?: string;
  /** Один раз: после первого появления наблюдение снимается */
  once?: boolean;
}

/**
 * Виден ли элемент. Свой хук на IntersectionObserver вместо useInView из Motion: тот тянул
 * библиотеку анимаций (~45 КБ gzip) в стартовый код ради одной проверки видимости
 */
export const useInView = (
  ref: RefObject<Element | null>,
  { margin = '0px', once = false }: InViewOptions = {},
): boolean => {
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const element = ref.current;
    if (!element) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry) return;
        setInView(entry.isIntersecting);
        if (entry.isIntersecting && once) observer.disconnect();
      },
      { rootMargin: margin },
    );
    observer.observe(element);
    return () => observer.disconnect();
  }, [ref, margin, once]);

  return inView;
};
